module.exports = __webpack_public_path__ + "static/media/lays.6c0906e0.png";